import { CreditCheckDetails } from './credit-check-details';

export interface CreditCheck {
  key: string;
  name: string;
  address: string;
  paymentTerms: string;
  creditLimit: string;
  totalXero: string;
  totalOutstandingOrder: string;
  balance: string;
  currency: string;
  currencySymbol: string;
  onStop: string;
  onStopString: string;

  creditCheckDetails: CreditCheckDetails[];
}
